import { NgModule }           from '@angular/core';
import { FormsModule }        from '@angular/forms';
import { PagesComponent }     from './pages.component';
import { ThemeTurModule }     from './tur/theme-tur.module';
import { PagesRoutingModule } from './pages-routing.module';
import { BrowserModule }      from '@angular/platform-browser';
import { ComponentsModule }   from '../components/components.module';
import { PipesModule }        from '../pipes/pipes.module';
import { DirectivesModule }   from '../directives/directives.module';
import { WarningComponent }   from './general/warning/warning.component';

const PAGES = [
	WarningComponent,
	PagesComponent
];

const THEMES = [
	ThemeTurModule
];

@NgModule({
	imports: [
		PagesRoutingModule,
		BrowserModule,
		FormsModule,
		ComponentsModule,
		PipesModule,
		DirectivesModule,

		...THEMES
	],
	exports: [
		...PAGES
	],
	declarations: [
		...PAGES
	]
})
export class PagesModule {
}
